/**
 * Visits and downloads go to Umami, self-hosted at stats.raiansar.com like Rai's other sites (no cookies).
 *
 * The page loads the tracker from there directly (index.html): through a Worker proxy every visitor would arrive
 * with the Worker's address, since the instance reads the visitor's from cf-connecting-ip. Downloads are counted once,
 * by the Worker on /download, as a "download" event: the page puts its visitor's source on the link (`downloadHref`),
 * and links from other sites bring their own Referer.
 */
export const UMAMI_ORIGIN = 'https://stats.raiansar.com';
/** Public by design: it is in the page's HTML. */
export const UMAMI_WEBSITE_ID = '947ae9c0-a3b2-4570-9070-646c15e408c3';
/** The tracker is renamed on this instance: /u.js, and events go to /api/e instead of /api/send. */
export const UMAMI_SCRIPT = `${UMAMI_ORIGIN}/u.js`;
export const UMAMI_EVENTS = `${UMAMI_ORIGIN}/api/e`;
export const SITE_HOST = 'warg.dev';

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

/** A host name as a referrer gives it, lowercased; null for anything else and for this site itself. */
export function sourceHost(value: string | null | undefined): string | null {
  if (!value) return null;
  let host = value;
  try {
    if (value.includes('/')) host = new URL(value).hostname;
  } catch {
    return null;
  }
  host = host.toLowerCase();
  if (!/^[a-z0-9.-]{1,253}$/.test(host) || host === SITE_HOST || host.endsWith(`.${SITE_HOST}`)) return null;
  return host;
}

/** /download, carrying where this visitor came from: the referring site (`ref`) and the page's utm_* tags. */
export function downloadHref(search: string, referrer: string): string {
  const from = new URLSearchParams(search);
  const to = new URLSearchParams();
  const ref = sourceHost(referrer);
  if (ref) to.set('ref', ref);
  for (const key of UTM_KEYS) {
    const value = from.get(key);
    if (value) to.set(key, value.slice(0, 100));
  }
  const query = to.toString();
  return query ? `/download?${query}` : '/download';
}
